import React from 'react';
import PropTypes from 'prop-types';
import { ACTUAL_VS_PLANNED_PROPERTY } from '../constants';

export default function ActualVsPlannedButton({ onButtonClicked, active }) {
  return (
    <button
      type="button"
      onClick={onButtonClicked}
      id="actual-vs-planned-button"
      style={{
        backgroundColor: active ? 'rgba(244, 244, 244, 0.9)' : '#fff',
      }}
    >
      <svg height="10" width="20">
        <path
          id="lineAB"
          d="M 0 5 L 16 5"
          stroke={ACTUAL_VS_PLANNED_PROPERTY.PLANNED.color}
          strokeWidth="2"
          fill="none"
        />
        Sorry, your browser does not support inline SVG.
      </svg>
      <span style={{ color: ACTUAL_VS_PLANNED_PROPERTY.PLANNED.color }}>Planned</span>
      &nbsp;vs&nbsp;
      <svg height="10" width="20">
        <path
          id="lineAB"
          d="M 0 5 L 16 5"
          stroke={ACTUAL_VS_PLANNED_PROPERTY.ACTUAL.color}
          strokeWidth="2"
          fill="none"
        />
        Sorry, your browser does not support inline SVG.
      </svg>
      <span style={{ color: ACTUAL_VS_PLANNED_PROPERTY.ACTUAL.color }}>Actual</span>
    </button>
  );
}

ActualVsPlannedButton.propTypes = {
  onButtonClicked: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};
